export class Category {
    Id_CategoryRecipe: number;
    CategoryName: string;
    SubCategoryName: string;
    RecipeGroup: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/category-model.ts